<template>
  <div
    @mousemove="dottedLineMove"
    @mouseup="dottedLineUp"
    @keyup="keyboard"
    :style="wrapperStyle"
    class="vue-ruler-wrapper"
    ref="vue-ruler-wrapper"
  >
    <section v-show="showRuler">
      <div
        v-if="request_prefix !== 'appStage'"
        ref="horizontalRuler"
        class="vue-ruler-h"
        @mousedown.stop="verticalDragRuler"
      >
        <canvas
          id="canvasH"
          :width="windowWidth + 'px'"
          :height="rulerThickness + 'px'"
          :style="canvasHMargin"
        ></canvas>
      </div>
      <div ref="verticalRuler" class="vue-ruler-v" @mousedown.stop="horizontalDragRuler">
        <canvas id="canvasV" :height="rulerWrapHeight + 'px'" :width="rulerThickness + 'px'"></canvas>
      </div>
      <div :style="{ top: `${verticalDottedTop - 10}px` }" class="vue-ruler-ref-dot-h"></div>
      <div :style="{ left: horizontalDottedLeft + 'px' }" class="vue-ruler-ref-dot-v"></div>
      <template v-for="(item, index) in lineList">
        <div
          v-if="request_prefix !== 'appStage' || (request_prefix === 'appStage' && item.type !== 'v')"
          :ref="`${item.type}`"
          :title="item.title"
          :style="getLineStyle(item, index)"
          :key="item.id"
          :class="`vue-ruler-ref-line-${item.type}`"
        ></div>
      </template>
      <template v-for="(item, index) in lineList">
        <div
          v-if="request_prefix !== 'appStage' || (request_prefix === 'appStage' && item.type !== 'v')"
          :key="index"
          :style="getMoveBtnStyle(item, index)"
          :class="`vue-ruler-ref-move-btn-${item.type}`"
          @mousedown="handleDragLine(item)"
        >
          <span
            class="icon icon-portal-close"
            @mousedown.stop
            @click.stop.prevent="deleteLine(item.type, index)"
          ></span>
        </div>
      </template>
    </section>
    <div ref="content" class="vue-ruler-content" id="vueRulerContent" :style="contentStyle">
      <div
        v-if="request_prefix === 'appStage' && showRuler"
        ref="horizontalRuler"
        class="vue-ruler-h"
        @mousedown.stop="verticalDragRuler"
      >
        <canvas
          id="canvasH"
          :width="windowWidth + 'px'"
          :height="rulerThickness + 'px'"
          :style="canvasHMargin"
        ></canvas>
      </div>
      <template v-for="(item, index) in lineList">
        <div
          v-if="request_prefix === 'appStage' && item.type === 'v'"
          :ref="`${item.type}`"
          :title="item.title"
          :style="getLineStyle(item, index)"
          :key="item.id"
          :class="`vue-ruler-ref-line-${item.type}`"
        ></div>
      </template>
      <template v-for="(item, index) in lineList">
        <div
          v-if="request_prefix === 'appStage' && item.type === 'v'"
          :key="index"
          :style="getMoveBtnStyle(item, index)"
          :class="`vue-ruler-ref-move-btn-${item.type}`"
          @mousedown="handleDragLine(item)"
        >
          <span
            class="icon icon-portal-close"
            @mousedown.stop
            @click.stop.prevent="deleteLine(item.type, index)"
          ></span>
        </div>
      </template>
      <slot></slot>
    </div>
    <div v-show="isDrag" class="vue-ruler-content-mask"></div>
  </div>
</template>

<script>
import { on, off } from "../../utils/index.js"
import { canvasRuler } from "../../utils/canvasRuler"

export default {
  name: "VRuler",
  components: {},
  props: {
    position: {
      type: String,
      default: "relative",
      validator: function (val) {
        return ["absolute", "fixed", "relative", "static", "inherit"].indexOf(val) !== -1
      }
    },
    zoom: {
      type: Number,
      default: 1
    },
    rulerThickness: {
      type: Number,
      default: 24
    },
    // 规定元素的定位类型
    isHotKey: {
      type: Boolean,
      default: true
    }, // 热键开关
    isScaleRevise: {
      type: Boolean,
      default: false
    }, // 刻度修正(根据content进行刻度重置)
    value: {
      type: Array,
      default: () => {
        return [] // { type: 'h', site: 50 }, { type: 'v', site: 180 }
      }
    }, // 预置参考线
    contentLayout: {
      type: Object,
      default: () => {
        return { top: 0, left: 0 }
      }
    }, // 内容部分布局
    parent: {
      type: Boolean,
      default: false
    },
    parentH: {
      type: Number,
      default: false
    },
    parentW: {
      type: Number,
      default: false
    },
    visible: {
      type: Boolean,
      default: true
    },
    stepLength: {
      type: Number,
      default: 100,
      validator: val => val % 10 === 0
    }, // 步长
    contentScrollLeft: {
      type: Number
    },
    contentScrollTop: {
      type: Number
    },
    contentWidth: {
      type: Number
    },
    appEditWidth: {
      type: Number
    },
    scrollLeft: {
      type: Number
    },
    scrollTop: {
      type: Number
    }
  },
  data() {
    return {
      size: 0,
      left_top: 0, // 内容左上填充
      windowWidth: 0, // 窗口宽度
      windowHeight: 0, // 窗口高度
      xScale: [], // 水平刻度
      yScale: [], // 垂直刻度
      topSpacing: 0, // 标尺与窗口上间距
      leftSpacing: 1920, //  标尺与窗口左间距
      isDrag: false,
      dragFlag: "", // 拖动开始标记，可能值x(从水平标尺开始拖动),y(从垂直标尺开始拖动)
      horizontalDottedLeft: -999, // 水平虚线位置
      verticalDottedTop: -999, // 垂直虚线位置
      rulerWidth: 0, // 垂直标尺的宽度
      rulerHeight: 0, // 水平标尺的高度
      dragLineId: "", // 被移动线的ID
      keyCode: {
        r: 82
      }, // 快捷键参数
      rulerWrapHeight: 800,
      rulerWrapWidth: 800,
      zoomChangeProportion: 1
    }
  },
  computed: {
    showRuler() {
      // 2.0默认隐藏标尺
      if (this.request_prefix === "bigScreen") {
        return this.$store.state.states.hasOwnProperty("showRuler") ? this.$store.state.states.showRuler : true
      } else {
        return this.$store.state.states.hasOwnProperty("showRuler") ? !this.$store.state.states.showRuler : false
      }
    },
    wrapperStyle() {
      let paddingTop = this.rulerThickness + "px"
      return {
        margin: this.request_prefix === "appStage" ? "0 auto" : undefined,
        padding: this.request_prefix !== "bigScreen" && !this.showRuler ? "0" : `${paddingTop} 0 0 0 `,
        height: this.windowHeight + "px",
        position: this.position
      }
    },
    contentStyle() {
      let paddingTop = this.left_top
      return {
        display: this.request_prefix === "stage"?'flex':'',
        left:
          this.request_prefix === "appStage" || (this.request_prefix === "stage" && !this.showRuler)
            ? "0px"
            : this.contentLayout.left + this.rulerThickness + "px", //24为标尺的宽度
        padding: paddingTop + "px 0px 0px " + this.left_top + "px",
        width:
          this.request_prefix === "stage" && !this.showRuler
            ? "100%"
            : this.request_prefix === "stage"
            ? "calc(100% - 24px)"
            : "none",
        margin: this.request_prefix === "appStage" ? "0 auto" : "none",
        height: this.request_prefix === "stage" && !this.showRuler ? "100%" : ""
      }
    },
    lineList() {
      let hCount = 0
      let vCount = 0
      return this.value.map(item => {
        const isH = item.type === "h"
        return {
          id: `${item.type}_${isH ? hCount++ : vCount++}`,
          type: item.type,
          title: (item.site + this.size).toFixed(2) / 2 + "px",
          [isH ? "top" : "left"]: item.site / (this.stepLength / 50) + this.size
        }
      })
    },
    getMoveBtnPosition() {
      let position = []
      this.lineList.forEach(item => {
        position.push({
          left: item.left - this.contentScrollLeft - 10,
          top: item.top - this.contentScrollTop - 10
        })
      })
      return position
    },
    getMoveBtnStyle() {
      return function ({ type, top, left }, index) {
        left = this.getMoveBtnPosition[index].left
        top = this.getMoveBtnPosition[index].top
        return type === "h"
          ? {
              top: top + "px",
              width: this.windowWidth + "px",
              minWidth: "100%",
              height: "0px",
              zIndex: "100001",
              position: "absolute",
              left: "0px",
              borderBottom: "10px solid transparent",
              borderTop: "10px solid transparent"
            }
          : {
              left: this.request_prefix === "appStage" ? left + "px" : left + this.rulerThickness + "px", //24为标尺的宽度
              width: "0px",
              height: this.rulerWrapHeight + "px",
              minHeight: "100%",
              zIndex: "100001",
              position: "absolute",
              top: "0px",
              borderLeft: "10px solid transparent",
              borderRight: "10px solid transparent"
            }
      }
    },
    getMoveLinePosition() {
      let position = []
      this.lineList.forEach(item => {
        position.push({
          left: item.left - this.contentScrollLeft,
          top: item.top - this.contentScrollTop
        })
      })
      return position
    },
    getLineStyle() {
      return function ({ type, top, left }, index) {
        left = this.getMoveLinePosition[index].left
        top = this.getMoveLinePosition[index].top
        return type === "h"
          ? {
              top: top + "px",
              width: this.windowWidth + "px",
              minWidth: "100%"
            }
          : {
              top: this.request_prefix === "appStage" ? -this.rulerThickness + "px" : "0px",
              left: this.request_prefix === "appStage" ? left + "px" : left + this.rulerThickness + "px",
              height: this.rulerWrapHeight + this.rulerThickness + "px",
              minHeight: "100%"
            } //24为标尺的宽度
      }
    },
    canvasHMargin() {
      return this.request_prefix === "appStage" ? "margin-left: -230px" : ""
    }
  },
  watch: {
    zoom(newVal, oldVal) {
      if (newVal && oldVal) {
        let leftOffset = 0
        let vueRulerContainer = document.getElementById("vueRulerContainer")
        // 重新计算标尺的位置
        if (this.request_prefix === "appStage" && vueRulerContainer) {
          let contentW = vueRulerContainer.getBoundingClientRect().width
          leftOffset = (contentW - this.appEditWidth * this.zoom) / 2
          this.zoomChangeProportion = newVal / oldVal
          this.getMoveBtnPosition.forEach(item => {
            item.left = item.left
              ? leftOffset +
                item.left * this.zoomChangeProportion -
                (contentW * this.zoomChangeProportion) / 2 +
                (this.appEditWidth * newVal) / 2 +
                14
              : item.left
            item.top = item.top ? item.top * this.zoomChangeProportion + 14 : item.top
          })
          this.getMoveLinePosition.forEach(item => {
            item.left = item.left
              ? leftOffset +
                item.left * this.zoomChangeProportion -
                (contentW * this.zoomChangeProportion) / 2 +
                (this.appEditWidth * newVal) / 2
              : item.left
            item.top = item.top ? item.top * this.zoomChangeProportion : item.top
          })
          this.lineList.forEach(item => {
            if (item.type === "v") {
              item.left = item.left
                ? leftOffset +
                  item.left * this.zoomChangeProportion -
                  (contentW * this.zoomChangeProportion) / 2 +
                  (this.appEditWidth * newVal) / 2
                : item.left
            } else {
              item.top = item.top
                ? (item.top - this.rulerThickness) * this.zoomChangeProportion + this.rulerThickness
                : item.top
            }
            item.title = item.left ? item.left + "px" : item.top + "px"
          })
          this.value?.forEach((item, index) => {
            if (item.type === "v") {
              item.site = this.lineList[index].left * 2
            } else {
              item.site = (item.site - 2 * this.rulerThickness) * this.zoomChangeProportion + 2 * this.rulerThickness
            }
          })
        } else {
          this.zoomChangeProportion = newVal / oldVal
          this.getMoveBtnPosition.forEach(item => {
            item.left = item.left ? item.left * this.zoomChangeProportion : item.left
            item.top = item.top
              ? (item.top + 14 - this.rulerThickness) * this.zoomChangeProportion + this.rulerThickness
              : item.top
          })
          this.getMoveLinePosition.forEach(item => {
            item.left = item.left ? item.left * this.zoomChangeProportion : item.left
            item.top = item.top
              ? (item.top - this.rulerThickness) * this.zoomChangeProportion + this.rulerThickness
              : item.top
          })
          this.lineList.forEach(item => {
            if (item.type === "v") {
              item.left = item.left ? item.left * this.zoomChangeProportion : item.left
            } else {
              item.top = item.top
                ? (item.top - this.rulerThickness) * this.zoomChangeProportion + this.rulerThickness
                : item.top
            }
            item.title = item.title ? parseFloat(item.title) * this.zoomChangeProportion + "px" : item.title
          })
          this.value?.forEach(item => {
            if (item.type === "v") {
              item.site = item.site * this.zoomChangeProportion
            } else {
              item.site = (item.site - 2 * this.rulerThickness) * this.zoomChangeProportion + 2 * this.rulerThickness
            }
          })
        }
      }
    },
    contentWidth(newVal, oldVal) {
      // 重新计算标尺的位置
      if (this.request_prefix === "appStage") {
        this.getMoveBtnPosition.forEach(item => {
          item.left = item.left ? (newVal - oldVal) / 2 + item.left : item.left
        })
        this.getMoveLinePosition.forEach(item => {
          item.left = item.left ? (newVal - oldVal) / 2 + item.left : item.left
        })
        this.lineList.forEach(item => {
          if (item.type === "v") {
            item.left = item.left ? (newVal - oldVal) / 2 + item.left : item.left
            item.title = item.left
          }
        })
        this.value.forEach((item, index) => {
          if (item.type === "v") {
            item.site = this.lineList[index].left * 2
          }
        })
      }
    },
    showRuler(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.rulerInit()
        })
      }
    }
  },
  mounted() {
    this.init()
    on(window, "resize", this.windowResize)
    on(window, "resize", this.computeDomSize)
  },
  beforeDestroy() {
    off(window, "resize", this.windowResize)
    off(window, "resize", this.computeDomSize)
  },
  methods: {
    init(left, top) {
      this.computeDomSize()
      this.box()
      this.scaleCalc()
      this.$nextTick(() => {
        this.getRulerWrapHeight()
        setTimeout(() => {
          if (document.getElementById("canvasH")) {
            this.rulerInit(left, top)
          }
        }, 20)
      })
    },
    getRulerWrapHeight() {
      if (document.getElementById("vueRulerContainer")) {
        const { offsetWidth, offsetHeight } = document.getElementById("vueRulerContainer")
        let minH = parseInt(offsetHeight)
        let minW = parseInt(offsetWidth)
        let maxH = minH > this.rulerHeight ? minH : this.rulerHeight
        let maxW = minW > this.rulerWidth ? minH : this.rulerWidth
        this.rulerWrapHeight = maxH
        this.rulerWrapWidth = maxW
      } else {
        this.rulerWrapHeight = this.rulerHeight
        this.rulerWrapWidth = this.rulerWrapWidth
      }
    },
    rulerInit(left, top) {
      let ruler = new canvasRuler({
        horizontalDom: "canvasH",
        verticalDom: "canvasV",
        zoom: this.zoom,
        tickColor: this.request_prefix === "bigScreen" ? "rgba(255,255,255,.4)" : "rgba(0,0,0,.4)",
        axisColor: this.request_prefix === "bigScreen" ? "rgba(255,255,255,.4)" : "rgba(0,0,0,.4)",
        axisMarginLeft: left || 0,
        axisMarginTop: top || 0
      })
      ruler.init()
    },
    windowResize() {
      this.xScale = []
      this.yScale = []
      this.init(this.contentScrollLeft, this.contentScrollTop)
    },
    computeDomSize() {
      const rect = document.getElementsByClassName("edit_bg")[0].getBoundingClientRect()
      this.editWidth = parseInt(rect.width)
      this.editHeight = parseInt(rect.height)
      if (this.showRuler && this.$refs.horizontalRuler) {
        const { x, y } = this.$refs.horizontalRuler.getBoundingClientRect()
        this.leftSpacing = x
        this.topSpacing = y
      }
    },
    handleDragLine({ type, id }) {
      this.$emit("lineClickEv")
      return type === "h" ? this.dragHorizontalLine(id) : this.dragVerticalLine(id)
    },
    box() {
      if (this.isScaleRevise) {
        // 根据内容部分进行刻度修正
        const content = this.$refs.content
        const contentLeft = content.offsetLeft
        const contentTop = content.offsetTop

        this.getCalcRevise(this.xScale, contentLeft)
        this.getCalcRevise(this.yScale, contentTop)
      }
      if (this.parent) {
        this.windowWidth =
          this.request_prefix === "appStage"
            ? Math.floor(this.appEditWidth * this.zoom)
            : this.editWidth
        this.windowHeight = this.editHeight
      } else {
        this.windowWidth =
          this.request_prefix === "appStage"
            ? Math.floor(this.appEditWidth * this.zoom)
            : document.documentElement.clientWidth - this.leftSpacing
        this.windowHeight = document.documentElement.clientHeight - this.topSpacing
      }
      if (!this.$refs.horizontalRuler) {
        return
      }
      this.rulerHeight = this.$refs.horizontalRuler.clientHeight
      this.rulerWidth = this.$refs.verticalRuler.clientWidth
    },
    scaleCalc() {
      this.getCalc(this.xScale, this.rulerWidth)
      this.getCalc(this.yScale, this.rulerHeight)
    }, // 计算刻度
    getCalc(array, length) {
      for (let i = 0; i < (length * this.stepLength) / this.stepLength; i += this.stepLength) {
        if (i % this.stepLength === 0) {
          array.push({ id: i })
        }
      }
    }, // 获取刻度方法
    getCalcRevise(array, length) {
      for (let i = 0; i < length; i += 1) {
        if (i % this.stepLength === 0 && i + this.stepLength <= length) {
          array.push({ id: i })
        }
      }
    }, // 获取矫正刻度方法
    newLine(val) {
      this.isDrag = true
      this.dragFlag = val
    }, // 生成一个参考线
    dottedLineMove($event) {
      switch (this.dragFlag) {
        case "x":
        case "h":
          if (this.isDrag) {
            this.verticalDottedTop = $event.pageY + 10 - this.topSpacing
          }
          break
        case "y":
        case "v":
          if (this.isDrag) {
            this.horizontalDottedLeft =
              this.request_prefix === "appStage"
                ? $event.pageX - this.$refs.content.getBoundingClientRect().x
                : $event.pageX - this.$refs.content.getBoundingClientRect().x + this.rulerThickness
          }
          break
        default:
          break
      }
    }, // 虚线移动
    dottedLineUp($event) {
      if (this.isDrag) {
        this.isDrag = false
        const cloneList = JSON.parse(JSON.stringify(this.value))
        switch (this.dragFlag) {
          case "x":
            cloneList.push({
              type: "h",
              site: (this.contentScrollTop + $event.pageY - this.topSpacing - this.size) * (this.stepLength / 50)
            })
            this.$emit("input", cloneList)
            break
          case "y":
            cloneList.push({
              type: "v",
              site:
                (this.contentScrollLeft + $event.pageX - this.$refs.content.getBoundingClientRect().x - this.size) *
                (this.stepLength / 50)
            })
            this.$emit("input", cloneList)
            break
          case "h":
            this.dragCalc(cloneList, this.contentScrollTop + $event.pageY, this.topSpacing, this.rulerHeight, "h")
            this.$emit("input", cloneList)
            break
          case "v":
            this.dragCalc(
              cloneList,
              this.contentScrollLeft + $event.pageX - this.$refs.content.getBoundingClientRect().x,
              0,
              this.rulerWidth,
              "v"
            )
            this.$emit("input", cloneList)
            break
          default:
            break
        }
        localStorage.setItem("rulers", JSON.stringify(cloneList))
        this.verticalDottedTop = this.horizontalDottedLeft = -9999
      }
    }, // 虚线松开
    dragCalc(list, page, spacing, ruler, type) {
      if (page - spacing < ruler) {
        let Index, id
        this.lineList.forEach((item, index) => {
          if (item.id === this.dragLineId) {
            Index = index
            id = item.id
          }
        })
        list.splice(Index, 1, {
          type: type,
          site: -600
        })
      } else {
        let Index, id
        this.lineList.forEach((item, index) => {
          if (item.id === this.dragLineId) {
            Index = index
            id = item.id
          }
        })
        list.splice(Index, 1, {
          type: type,
          site: (page - spacing - this.size) * (this.stepLength / 50)
        })
      }
    },
    horizontalDragRuler() {
      this.$emit("rulerClickEv")
      this.newLine("x")
    }, // 水平标尺处按下鼠标
    verticalDragRuler() {
      this.newLine("y")
    }, // 垂直标尺处按下鼠标
    dragHorizontalLine(id) {
      this.isDrag = true
      this.dragFlag = "h"
      this.dragLineId = id
    }, // 水平线处按下鼠标
    dragVerticalLine(id) {
      this.isDrag = true
      this.dragFlag = "v"
      this.dragLineId = id
    }, // 垂直线处按下鼠标
    keyboard($event) {
      if (this.isHotKey) {
        switch ($event.keyCode) {
          case this.keyCode.r:
            this.rulerToggle = !this.rulerToggle
            this.$emit("update:visible", this.rulerToggle)
            if (this.rulerToggle) {
              this.left_top = 18
            } else {
              this.left_top = 0
            }
            break
        }
      }
    }, // 键盘事件
    // 删除辅助线
    deleteLine(type, index) {
      this.lineList.splice(index, 1)
      this.value.splice(index, 1)
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.vue-ruler-wrapper {
  left: 0;
  z-index: 10;
  user-select: none;
}
.vue-ruler-ref-line-v:before {
  position: absolute;
  top: 0;
  left: -8px;
  content: "";
  z-index: 10001;
  border-width: 8px;
  border-style: solid;
  border-color: var(--themeColor) transparent transparent;
}
.vue-ruler-ref-line-h:before {
  position: absolute;
  top: -8px;
  left: 0;
  content: "";
  z-index: 10000;
  border-width: 8px;
  border-style: solid;
  border-color: transparent transparent transparent var(--themeColor);
}
.vue-ruler-h,
.vue-ruler-ref-line-h,
.vue-ruler-ref-dot-h {
  position: absolute;
  left: 0;
  top: 60px;
  z-index: 10000;
}
.vue-ruler-v,
.vue-ruler-ref-line-v,
.vue-ruler-ref-dot-v {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10000;
}
.bigScreen .vue-ruler-h {
  top: 0;
  left: 24px;
}
.bigScreen .vue-ruler-v {
  left: 0;
}

.vue-ruler-h {
  width: 100%;
  height: 24px;
  left: 0;
  opacity: 0.6;
  background: var(--rulerBgColor);
}

.vue-ruler-v {
  width: 24px;
  height: 100%;
  top: 24px;
  opacity: 0.6;
  background: var(--rulerBgColor);
}

.vue-ruler-v .n,
.vue-ruler-h .n {
  position: absolute;
  cursor: default;
  font-size: 9px;
  line-height: 13px;
  color: rgba(0, 0, 0, 0.4);
}

.vue-ruler-v .n {
  width: 8px;
  left: 3px;
  word-wrap: break-word;
}

.vue-ruler-h .n {
  top: 6px;
}

.vue-ruler-ref-line-v,
.vue-ruler-ref-line-h,
.vue-ruler-ref-dot-h,
.vue-ruler-ref-dot-v {
  z-index: 998;
}
.vue-ruler-ref-move-btn-v .icon,
.vue-ruler-ref-move-btn-h .icon {
  position: absolute;
  display: none;
  color: var(--themeColor);
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
}
.vue-ruler-ref-move-btn-v .icon {
  top: 2px;
  left: 8px;
}
.vue-ruler-ref-move-btn-h .icon {
  bottom: 6px;
  left: 2px;
}
.vue-ruler-ref-move-btn-v:hover .icon,
.vue-ruler-ref-move-btn-h:hover .icon {
  display: inline-block;
}
.vue-ruler-ref-line-h {
  width: 100%;
  height: 1px;
  background-color: var(--themeColor);
  position: absolute !important;
}

.vue-ruler-ref-line-v {
  width: 1px;
  height: 100%;
  _height: 9999px;
  background-color: var(--themeColor);
}

.vue-ruler-ref-move-btn-h {
  cursor: url("../../assets/images/top_bottom.png"), auto;
}
.vue-ruler-ref-move-btn-v {
  cursor: url("../../assets/images/left_right.png"), auto;
}
#vueRulerContent .vue-ruler-ref-move-btn-v {
  top: -24px !important;
}

.vue-ruler-ref-dot-h {
  width: 100%;
  height: 3px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAMAAABFaP0WAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFf39/////F3PnHQAAAAJ0Uk5T/wDltzBKAAAAEElEQVR42mJgYGRgZAQIMAAADQAExkizYQAAAABJRU5ErkJggg==)
    repeat-x left 1px; /*./image/line_dot.png*/
  cursor: n-resize; /*url(./image/cur_move_h.cur), move*/
}

.vue-ruler-ref-dot-v {
  width: 3px;
  height: 100%;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAMAAABFaP0WAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFf39/////F3PnHQAAAAJ0Uk5T/wDltzBKAAAAEElEQVR42mJgYGRgZAQIMAAADQAExkizYQAAAABJRU5ErkJggg==)
    repeat-y 1px top; /*./image/line_dot.png*/
  cursor: w-resize; /*url(./image/cur_move_v.cur), move*/
}
.vue-ruler-content {
  position: relative;
  z-index: 997;
  height: calc(100% - 20px);
}
.vue-ruler-content-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 998;
}
.container-wrap {
  overflow: auto;
}
</style>
